import { isAbandonedPlat } from "../utils";
import { BaseSDK, SDKConfig } from "./base";
import { SDKName } from "./types";

interface GoogleAnalyticsConfig extends SDKConfig {
  trackingId: string;
}

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export class GlobalGASDK extends BaseSDK {
  private trackingId: string;

  constructor(config: GoogleAnalyticsConfig) {
    super(SDKName.GlobalGASDK, config);
    this.trackingId = config.trackingId;
  }

  async initialize(): Promise<void> {
    if (isAbandonedPlat()) {
      return;
    }
    const gaScript = document.createElement("script");
    gaScript.async = true;
    gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.trackingId}`;
    document.head.appendChild(gaScript);

    // 2️⃣ 创建内联脚本
    const inlineScript = document.createElement("script");
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${this.trackingId}');
    `;
    document.head.appendChild(inlineScript);
  }

  reportEvent(event: string, data: Record<string, unknown> = {}): boolean {
    if (!window.gtag) {
      console.error("window.gtag is not defined");
      return false;
    }

    window.gtag("event", event, {
      ...data,
      send_to: this.trackingId, // ✅ 强制只发到当前 GA
      ga_instance: "GlobalGASDK",
    });

    return true;
  }
}
